import React from 'react';
import Select from 'react-select';
import _ from 'lodash';

const INVALID_RED_COLOR = 'rgb(244, 67, 54)';

const errorStyle = {
    bottom: 15,
    fontSize: 12,
    margin: 12,
    color: INVALID_RED_COLOR,
    transition: 'all 450ms'
};

class RFSelect extends React.PureComponent {
    componentWillReceiveProps({ options, manual, input: { value } }) {
        const valKey = this.props.valueKey || 'value';
        const hasValue = options.find(el => el[valKey] === value);
        if (!manual && value && !hasValue) {
            this.handleInputChange();
        }
    }

    handleInputChange = obj => {
        const valKey = this.props.valueKey || 'value';
        const res = obj ? obj[valKey] : '';
        this.props.input.onChange(res);
        this.props.input.onBlur(res);
        if (this.props.onChange) {
            this.props.onChange(res);
        }
    };

    render() {
        const { props } = this;
        const valKey = this.props.valueKey || 'value';
        const { input, options, meta, onChange, ...rest } = props;
        const { name, value, onBlur, onChange: rfOnChange, onFocus } = input;
        const shouldShowError = meta.touched && !meta.valid;
        return (
            <div>
                <Select
                    {...rest}
                    name={name}
                    options={options}
                    onChange={this.handleInputChange}
                    value={value}
                    onBlur={() => onBlur(value)}
                    onFocus={onFocus}
                    style={shouldShowError ? { borderColor: INVALID_RED_COLOR } : {}}
                />
                {shouldShowError && <div style={errorStyle}>{meta.error}</div>}
            </div>
        );
    }
}

export default RFSelect;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/RFSelect.js
 **/